export default defineNuxtRouteMiddleware((to) => {
    if (to.path.includes('koopilot/app')) {
        const headers = useRequestHeaders()
        const userAgent = (headers['user-agent'] || '').toLowerCase()
        
        if (userAgent.includes('iphone')) {
          return navigateTo('https://apps.apple.com/sk/app/koopilot/id6630386264', { external: true })
        } else if (userAgent.includes('android') && userAgent.includes('mobile')) {
          return navigateTo('https://play.google.com/store/apps/details?id=sk.koop.koopilot', { external: true })
        } else {
            return navigateTo('/koopilot', { redirectCode: 301 })
        }
    }
})